import type { TokenUsdPriceData } from "@src/components/DefuseSDK/hooks/useTokensUsdPrices"
import type { TokenInfo } from "@src/components/DefuseSDK/types/base"
import { getTokenPrice } from "@src/components/DefuseSDK/utils/getTokenUsdPrice"

/** Per-share USD for vault tokens from the held-token oracle. */
export function resolveVaultSharePriceUsd(params: {
  vaultToken: TokenInfo
  tokensUsdPriceData?: TokenUsdPriceData
}): number | null {
  return getTokenPrice(params.vaultToken, params.tokensUsdPriceData)
}

export function resolveVaultSharePriceUsdc(params: {
  vaultToken: TokenInfo
  paymentToken: TokenInfo
  tokensUsdPriceData?: TokenUsdPriceData
}): number | null {
  const sharePriceUsd = getTokenPrice(
    params.vaultToken,
    params.tokensUsdPriceData
  )
  const usdcPriceUsd = getTokenPrice(
    params.paymentToken,
    params.tokensUsdPriceData
  )
  if (
    sharePriceUsd == null ||
    usdcPriceUsd == null ||
    !Number.isFinite(sharePriceUsd) ||
    !Number.isFinite(usdcPriceUsd) ||
    sharePriceUsd <= 0 ||
    usdcPriceUsd <= 0
  ) {
    return null
  }
  const sharePriceUsdc = sharePriceUsd / usdcPriceUsd
  return Number.isFinite(sharePriceUsdc) && sharePriceUsdc > 0
    ? sharePriceUsdc
    : null
}
